export default function StepsIndicator({ currentStep = 2 }: { currentStep: number }) {
  return (
    <div className="w-full px-12">
      <div className="relative flex items-center justify-between w-full">
        <div className="absolute left-0 top-2/4 h-0.5 w-full -translate-y-2/4 bg-gray-300"></div>
        <div
          className={`absolute left-0 top-2/4 h-0.5 -translate-y-2/4 bg-[#354297] transition-all duration-300`}
          style={{
            width: `${(currentStep - 1) * 50}%`, 
          }}
        ></div>
        <div
          className={`relative z-10 grid w-10 h-10 font-bold rounded-full place-items-center ${
            currentStep > 0 ? 'bg-[#354297] text-white' : 'border-gray-300 bg-white text-gray-400'
          }`}
        >
          1
          <div className="absolute -bottom-[2rem] w-max text-center">
            <p className="block font-sans text-sm antialiased font-normal leading-relaxed tracking-normal text-lavender-900">
              Setup Password
            </p>
          </div>
        </div>
        <div
          className={`relative z-10 grid w-10 h-10 font-bold rounded-full place-items-center ${
            currentStep > 1 ? 'bg-[#354297] text-white' : 'border-gray-300 bg-white text-gray-400'
          }`}
        >
          2
          <div className="absolute -bottom-[2rem] w-max text-center">
            <p className="block font-sans text-sm antialiased font-normal leading-relaxed tracking-normal text-lavender-900">
              Setup 2FA
            </p>
          </div>
        </div>
        <div
          className={`relative z-10 grid w-10 h-10 font-bold  rounded-full place-items-center ${
            currentStep > 2 ? 'bg-[#354297] text-white' : 'border-gray-300 bg-white text-gray-400'
          }`}
        >
          3
          <div className="absolute -bottom-[2rem] w-max text-center">
            <p className="block font-sans text-sm antialiased font-normal leading-relaxed tracking-normal text-lavender-900">
              Finish
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
